<div class="confirmation-container">
  <div class="header">
    <h2 class="title">{{ title || 'Deposit' }}</h2>
    <button type="button" class="share-button" (click)="onShareClick()">
      <svg
        class="share-icon"
        width="16"
        height="18"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        >
        <path
          d="M13 6C14.0667 6 15 5.06667 15 4C15 2.93333 14.0667 2 13 2C11.9333 2 11 2.93333 11 4C11 4.26667 11.0667 4.53333 11.1667 4.76667L5.73333 7.98333C5.33333 7.58333 4.7 7.33333 4 7.33333C2.93333 7.33333 2 8.26667 2 9.33333C2 10.4 2.93333 11.3333 4 11.3333C4.7 11.3333 5.33333 11.0833 5.73333 10.6833L11.1667 13.9C11.0667 14.1333 11 14.4 11 14.6667C11 15.7333 11.9333 16.6667 13 16.6667C14.0667 16.6667 15 15.7333 15 14.6667C15 13.6 14.0667 12.6667 13 12.6667C12.3 12.6667 11.6667 12.9167 11.2667 13.3167L5.83333 10.1C5.93333 9.86667 6 9.6 6 9.33333C6 9.06667 5.93333 8.8 5.83333 8.56667L11.2667 5.35C11.6667 5.75 12.3 6 13 6Z"
          fill="#08B5A3"
          />
      </svg>
      Share
    </button>
  </div>

  <div class="qr-section">
    <img
      [src]="qrCodeImageSrc"
      alt="QR Code for wallet address"
      class="qr-code"
      />
  </div>

  <div class="info-section">
    <div class="info-label">{{ label }}</div>
    <app-text-input [ngModel]="name" [readOnly]="true">
      <div icon>
        <div class="entity-icon"></div>
      </div>
    </app-text-input>
  </div>
  @if(!isSettlementApp && userType){
    <div class="info-section">
      <div class="info-label">{{ userType }}</div>
      <app-text-input [ngModel]="identifier" [readOnly]="true">
        <div icon>
          <div class="entity-icon"></div>
        </div>
      </app-text-input>
    </div>
  }
  @if(!isSettlementApp && blockchainLabel){
    <div class="info-section">
      <div class="info-label">Blockchain</div>
      <app-text-input [ngModel]="blockchainLabel" [readOnly]="true">
        <div icon>
          <div class="entity-icon"></div>
        </div>
      </app-text-input>
    </div>
  }
  <div class="info-section">
    <div class="info-label">Currency</div>
    <app-text-input [ngModel]="currency | uppercase" [readOnly]="true">
      <div icon>
        <div class="entity-icon"></div>
      </div>
    </app-text-input>
  </div>
  <div class="info-section">
    <div class="info-label">Wallet Address</div>
    <app-text-input
      [ngModel]="walletAddress"
      [showCopyIcon]="true"
      [readOnly]="true"
      >
      <div>
        <svg
          width="18"
          height="21"
          viewBox="0 0 18 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          >
          <path
            d="M13.5 0H2.25C1.00781 0 0 1.00781 0 2.25V15.75H2.25V2.25H13.5V0ZM16.3125 4.5H5.625C4.38281 4.5 3.375 5.50781 3.375 6.75V20.25C3.375 21.4922 4.38281 22.5 5.625 22.5H16.3125C17.5547 22.5 18.5625 21.4922 18.5625 20.25V6.75C18.5625 5.50781 17.5547 4.5 16.3125 4.5ZM16.3125 20.25H5.625V6.75H16.3125V20.25Z"
            fill="#84C4BD"
            />
        </svg>
      </div>
    </app-text-input>
  </div>

  @if (amount) {
    <div class="info-section">
      <div class="info-label">Amount</div>
      <app-text-input [ngModel]="amount" [readOnly]="true">
        <div icon>
          <div class="entity-icon"></div>
        </div>
      </app-text-input>
    </div>
  }

  <p class="disclaimer">
    Cryptocurrency deposits are final and cannot be reversed. Ensure that you
    are sending funds to the correct address.
  </p>

  <div class="button-container">
    <app-button buttonVariant="confirmation-primary" buttonType="button" (buttonClick)="onNewDepositClick()">
      {{ actionButtonText || 'New Deposit' }}
    </app-button>
  </div>
</div>

<!-- Printable Confirmation Summary -->
<div
  class="confirmation-container pdf-clone"
  #pdfCloneContainer
  aria-hidden="true"
  >
  <div class="header">
    <h2 class="title">{{ title || 'Deposit' }}</h2>
    <img src="shared-assets/Olivepay_logo.png" alt="Olivepay logo" class="pdf-logo" />
  </div>
  <div class="info-container">
    <div class="qr-section">
      <img
        [src]="qrCodeImageSrc"
        alt="QR Code for wallet address"
        class="qr-code"
        />
    </div>

    <div class="info-section">
      <div class="info-label">{{ label }}</div>
      <div class="print-input">{{ name }}</div>
    </div>

    @if(!isSettlementApp && userType){
      <div class="info-section">
        <div class="info-label">{{ userType }}</div>
        <div class="print-input">{{ identifier }}</div>
      </div>
    }

    @if(!isSettlementApp && blockchainLabel) {
      <div class="info-section">
        <div class="info-label">Blockchain</div>
        <div class="print-input">{{ blockchainLabel }}</div>
      </div>
    }

    <div class="info-section">
      <div class="info-label">Currency</div>
      <div class="print-input">{{ currency || '' | uppercase }}</div>
    </div>


    <div class="info-section">
      <div class="info-label">Wallet Address</div>
      <div class="print-input break-all olv-address">{{ walletAddress }}</div>
    </div>


    @if (amount) {
      <div class="info-section">
        <div class="info-label">Amount</div>
        <div class="print-input olv-figure">{{ amount }}</div>
      </div>
    }

    <p class="disclaimer">
      Cryptocurrency deposits are final and cannot be reversed. Ensure that you are sending funds to the correct
      address.
    </p>
  </div>
</div>
